<template lang="html">
    <router-link
        :to="{ name: route , params: routeParams}"
        :class="css"
        class="home-tile">

        <div
            v-if="icon"
            class="tile-icon">
            <v-icon
                :name="icon">
            </v-icon>
        </div>

        <div
            v-if="icon"
            class="tile-icon-bg">
            <v-icon
                :name="icon">
            </v-icon>
        </div>

        <div class="tile-text">
            <h2>{{ title }}</h2>
            <p v-if="subtitle">{{ subtitle }}</p>
            <div
                v-if="info"
                class="tile-info">
                {{ info }}
            </div>
        </div>

    </router-link>
</template>

<script>
export default {
    name: 'HomeTile',
    props: {
        title: {
            type: String,
            default: ''
        },
        subtitle: {
            type: String,
            default: ''
        },
        info: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: ''
        },
        route: {
            type: String,
            required: true
        },
        routeParams: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        css () {
            return this.route ? 'tile-' + this.route.toLowerCase() : '';
        }
    }
};
</script>

<style lang="scss">
@import '../../../assets/styles/variables';
.home-tile {
    display: block;
    position: relative;
    border-radius: 4px;
    background: #ccc;
    padding: 10px;
    color: white;
    text-decoration: none;
    transition: background .2s ease-in-out;
    margin: 10px 0;
    overflow: hidden;
    &:hover {
        color: white;
        text-decoration: none;
    }
    h2,
    p {
        margin: 0;
    }
    h2 {
        font-size: 30px;
        font-weight: bold;
    }
    .tile-icon {
        position: absolute;
        left: 20px;
        top: 50%;
        transform: translate(0, -50%);
        font-size: 20px;
        height: 20px;
    }
    .tile-icon-bg {
        position: absolute;
        right: -15%;
        top: 75%;
        transform: translate(-50%, -50%) rotate(-15deg);
        font-size: 300px;
        height: 300px;
        opacity: .2;
    }
    .tile-info {
        display: inline-block;
        line-height: 30px;
        background: rgba(white, .3);
        margin-top: 10px;
        padding: 0 15px;
        border-radius: 15px;
    }

    // 'tile-' + route.toLowerCase()
    &.tile-site {
        background: #FFA02F;
        &:hover {
            background: rgba(#FFA02F, .7);
        }
    }
    &.tile-status {
        background: #FFA02F;
        &:hover {
            background: rgba(#FFA02F, .7);
        }
    }
    &.tile-selection {
        background: #FE5815;
        &:hover {
            background: rgba(#FE5815, .7);
        }
    }
    &.tile-motors {
        background: #005BBB;
        &:hover {
            background: rgba(#005BBB, .7);
        }
    }

    @media screen and (min-width: $bp) {
        padding: 20px;
        padding-left: 100px;
        min-height: 140px;
        .tile-icon {
            font-size: 50px;
            height: 50px;
            left: 30px;
            top: 45px;
        }
    }
}

.el-col-8 .home-tile {
    padding-left: 10px;
    @media screen and (min-width: $bp) {
        padding-left: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Home/HomeTile.vue